var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'checkout-timer',
    _vm.state_class,
    { 'checkout-timer--minimal': _vm.minimal },
  ]},[_vm._v(" "+_vm._s(_vm.display)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }